import React, {Suspense, useMemo, useRef} from 'react';
// import JoditEditor from "jodit-react";
import styles from './TextEditor.module.css'
import Buttons, {EnumColors, EnumButtonWeight} from "../Buttons/Buttons/Buttons";

const JoditEditor = React.lazy(() => import("jodit-react"))


interface IProps {
    setValue: (value: string) => void,
    value: string,
    config?: object,
    setIsEditMode?: (status: boolean) => void,
    updateText?: () => void
}

const TextEditor = ({
                        setValue,
                        value,
                        config,
                        setIsEditMode,
                        updateText
                    }: IProps) => {


    const editor = useRef(null)

    const defaultConfig = useMemo(() => {
        return {
            language: 'ru',
            hidePoweredByJodit: true,
            className: styles.textStyle,
        }
    }, [])


    return (
        <div className={styles.wrapper}>
            <Suspense>
                <JoditEditor ref={editor} onChange={content => setValue(content)} value={value} config={config || defaultConfig}/>
            </Suspense>


            {setIsEditMode && updateText && <div className={styles.buttonsWrapper}>
                <Buttons color={EnumColors.white} weight={EnumButtonWeight.slim}
                         onClick={() => setIsEditMode(false)}>Отменить</Buttons>
                <Buttons color={EnumColors.white} weight={EnumButtonWeight.slim}
                         onClick={() => updateText()}>Применить</Buttons>
            </div>}

        </div>
    )
};

export default TextEditor;